import React, { useState, useEffect } from "react";
import "./price.scss";
import { v4 as uuidv4 } from "uuid";
import Link from "next/link";
import { toast } from "react-toastify";
import Image from "next/image";
import UserDB from "@/utils/userdb";
import axios from "axios";
import { useRouter } from "next/navigation";
import { useMediaQuery } from "react-responsive";
import BillingInfoForm from "./billingForm";
import { useSelector } from "react-redux";
import PaypalButton from "./paypalButton";

const paymentMethods = [
  {
    id: "credit",
    label: "UPI/ Credit/ Debit Card",
    images: [
      "/price-page/icons-01.png",
      "/price-page/icons-03.png",
      "/price-page/icons-05.png",
      // "/price-page/icons-04.png",
    ],
    // forIndian: true,
  },
  // {
  //   id: "paypal",
  //   label: "PayPal",
  //   images: ["/price-page/icons-08.png"],
  //   forIndian: false,
  // },877777
];
const paymentImages = [
  "/price-page/icons-01.png",
  "/price-page/icons-03.png",
  "/price-page/icons-04.png",
  "/price-page/icons-05.png",
  // "/price-page/icons-08.png",
];

const orderSummaryItems = [
  "50 Photo Credits (Use anywhere on snapshawt)",
  "No Watermark",
  "HD Images Download",
  "Access to all Templates",
  "Early access to new features",
  "Priority processing",
];

// toast options
const toastOptions = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export default function PriceComponent() {
  const router = useRouter();
  const [price, setPrice] = useState("$ 4.99");
  const [isMobileView, setIsMobileView] = useState(false);
  const [isForm, setIsForm] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    email: "",
    pincode: "",
    billingAddress: "",
    isGstRequired: false,
    gstCompanyName: "",
    gstNumber: "",
  });
  const [isUserIndian, setIsUserIndian] = useState();

  const [userBillingInfo, setUserBillingInfo] = useState();
  const userDataSelector = useSelector((data) => data.userData.user);
  const [currentBilling, setCurrentBilling] = useState();
  const [isShowOldBillingInfo, setIsShowOldBillingInfo] = useState();
  const [isGetBillingData, setIsGetBillingData] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("credit");

  // get user billing info
  // console.log(currentBilling);

  useEffect(() => {
    const getBillingData = async () => {
      try {
        let res = await axios.get(
          `${process.env.SERVER_BASE_URL}/billing-info/getAllByUserid/${userDataSelector?._id}`,
        );
        setUserBillingInfo(res.data);
        setCurrentBilling(res?.data[0]);
        setIsShowOldBillingInfo(true);
        // console.log(res);
      } catch (err) {
        console.log(err);
      }
    };

    if (userDataSelector?._id) {
      getBillingData();
    }
  }, [userDataSelector, isGetBillingData]);

  // mobile view
  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  useEffect(() => {
    if (UserDB.isUserIndian()) setPrice("INR 399");
    else setPrice("$ 4.99");
    console.log(UserDB.isUserIndian(), "is user indian");
    setSelectedMethod("credit");
    if (UserDB.isUserIndian()) {
      setIsUserIndian(true);
    } else {
      setIsUserIndian(false);
      // setSelectedMethod("paypal");
    }
    setIsMobileView(isMobile);
  }, [isMobile]);

  // update it for each payment
  let paymentGatewayLink = "";

  const handlePaymentMethodSelect = (method) => {
    setSelectedMethod(method);
  };

  function openPaymentPopup(paymentGatewayLink) {
    // Set the popup dimensions
    var popupWidth = 460;
    var popupHeight = 580;

    // Get the screen width and height
    var screenWidth =
      window.innerWidth || document.documentElement.clientWidth || screen.width;
    var screenHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      screen.height;

    // Calculate the center position for the popup
    var left = screenWidth / 2 - popupWidth / 2;
    var top = screenHeight / 2 - popupHeight / 2;

    // Open the centered popup with proper formatting
    var newWindow = window.open(
      paymentGatewayLink,
      "paymentPopup",
      `scrollbars=yes,resizable=no,width=${popupWidth},height=${popupHeight},top=${top},left=${left}`,
    );

    // Focus on the new window in case it was blocked
    if (newWindow) {
      newWindow.focus();
    } else {
      alert("Please allow popups for this website");
    }
  }

  function openPayUFormHTMLInNewTab(formHtmlString) {
    const newWindow = window.open("", "_blank");

    if (!newWindow) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    // Wait for the new window to be ready, then inject HTML and submit
    newWindow.document.open();
    newWindow.document.write(formHtmlString); // Safe here since it's a blank window
    newWindow.document.close();

    // Submit the form once it appears
    const maxRetries = 20;
    let attempts = 0;

    const interval = setInterval(() => {
      try {
        const form = newWindow.document.querySelector("form");

        if (form) {
          form.submit();
          clearInterval(interval); // ✅ Stop after submitting the form
        } else if (attempts > maxRetries) {
          clearInterval(interval);
          newWindow.close();
          alert("Payment form not found.");
        }

        attempts++;
      } catch (err) {
        // ✅ Catches SecurityError after the page navigates to PayU
        clearInterval(interval);
      }
    }, 100);
  }

  const handleConfirmAndPay = async () => {
    const user = UserDB.getUser();

    if (!user) {
      router.push("/signin?path=%2Fpricing");
      return;
    }

    if (selectedMethod) {
      // checking payment method is credit or paypal
      if (selectedMethod === "credit") {
        // it is for fast empty popup loading
        // openPaymentPopup(paymentGatewayLink);

        // const data = {
        //   userId: user._id,
        //   amount: "399",
        //   name: user._id,
        //   MUID: "MUID" + Date.now(),
        //   transactionId: "T" + Date.now(),
        // };
        const isIndian = UserDB.isUserIndian();
        const txnid = `TN-${uuidv4()}`;
        const data = {
          userId: user._id,
          amount: "399",
          firstname: currentBilling.name,
          phone: currentBilling.phone,
          email: currentBilling.email,
          isIndian,
          txnid,
        };

        try {
          const result = await axios.post(
            `${process.env.SERVER_BASE_URL}/payu/initiate-payment`,
            data,
            {
              headers: { "Content-Type": "application/json" },
              responseType: "text/html",
            },
          );

          if (result.data && result.data.includes("<form")) {
            openPayUFormHTMLInNewTab(result.data);
          } else {
            alert("Payment form not found.");
          }

          // if (form) form.submit();
          // else alert("Payment form not found");

          // Inject and submit the form safely
          // const container = document.createElement("div");
          // container.innerHTML = result.data;
          // document.body.appendChild(container);

          // const form = container.querySelector("form");
          // if (form) form.submit();
          // else alert("Payment form not found");
        } catch (error) {
          console.log(error);
          alert("Payment initiation failed");
        }

        // axios
        //   .post(process.env.SERVER_BASE_URL + "/payment/post", data)
        //   .then((response) => {
        //     // if (response.status == 200) setLoading(false);
        //     // console.log(response.data)
        //     openPaymentPopup(response.data);
        //   })
        //   .catch((error) => {
        //     // setLoading(false);
        //     console.log(error);
        //   });
      } else {
        // paymentGatewayLink = "paypal-link";
        toast.error("Please select another payment method", toastOptions);
      }

      // openPaymentPopup(paymentGatewayLink);
    } else {
      toast.error("Please select a payment method", toastOptions);
    }
  };

  return (
    <div className="flex-row-center payment-section">
      {/* left-part */}
      <div className="flex-col-center left-form-section">
        {/* left-title */}
        <div className="flex-row-center premium-icon-container">
          <div className="flex-row-center premium-icon">
            <Image
              src="/price-page/icons-06.png"
              alt="price-icon"
              width={150}
              height={150}
            />
          </div>
          <h1 className="heading-txt">Snapshawt Premium</h1>
        </div>

        {/* left-content */}
        <div className="flex-col-center left-content">
          <ul className="flex-col-center list-items-container">
            {orderSummaryItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>

          <ul className="flex-col-center features">
            <li>100% secure payment encryption</li>
            <li>Instant activation</li>
            <li>24/7 technical service</li>
          </ul>

          {/* left-icons-container */}
          <div className="flex-row-center left-icons-container">
            {paymentImages.map((image, index) => (
              <div key={index} className="payment-icon">
                <Image
                  src={image}
                  width={150}
                  height={150}
                  alt={`Payment method ${index + 1}`}
                  className={index === 4 ? "paypal-icon" : "payment-icon"}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* right-part */}
      {isForm ? (
        <div className="flex-col-center right-section">
          <BillingInfoForm
            setCurrentBilling={setCurrentBilling}
            currentBilling={currentBilling}
            userBillingInfo={userBillingInfo}
            formData={formData}
            setFormData={setFormData}
            setIsForm={setIsForm}
            isShowOldBillingInfo={isShowOldBillingInfo}
            setIsShowOldBillingInfo={setIsShowOldBillingInfo}
            userDataSelector={userDataSelector}
            setIsGetBillingData={setIsGetBillingData}
          />
        </div>
      ) : (
        <div className="flex-col-center right-section">
          <div className="flex-col-center payment-method">
            <p className="right-heading-txt">Payment method</p>
            <div className="flex-col-center payment-methods-container">
              {paymentMethods.map((method, index) => (
                <div
                  key={index}
                  onClick={() => handlePaymentMethodSelect(method.id)}
                  className="flex-row-center payment-method-item"
                  // style={{
                  //   display: method.forIndian == isUserIndian ? "flex" : "none",
                  // }}
                >
                  <input
                    type="radio"
                    name="payment-method"
                    value={method.id}
                    checked={selectedMethod === method.id}
                  />

                  <label className="flex-row-center payment-label">
                    <p className="labelTxt">{method.label}</p>

                    <div className="flex-row-center payment-icons-container">
                      {method.images.map((image, imgIndex) => (
                        <div
                          key={imgIndex}
                          className="flex-row-center payment-icon"
                          style={
                            isMobileView && imgIndex === 1
                              ? { display: "none" }
                              : {}
                          }
                        >
                          <Image
                            src={image}
                            alt={`${method.label}-icon`}
                            className={"payment-icon"}
                            width={150}
                            height={150}
                          />
                          {/* <Image
                            src={image}
                            alt={`${method.label}-icon`}
                            className={
                              method.id === "paypal"
                                ? "paypal-icon"
                                : "payment-icon"
                            }
                            width={150}
                            height={150}
                          /> */}
                        </div>
                      ))}
                    </div>
                  </label>
                </div>
              ))}
            </div>
            <div className="flex-col-center bill-section">
              <div className="flex-row-center total-bill-container borderBottom">
                <p className="totalTxt">Subtotal</p>
                <p className="totalTxt">{price}</p>
              </div>
              <div className="flex-row-center total-bill-container ">
                <p className="totalCostTxt">Total Cost</p>
                <p className="totalCostTxt">{price} </p>
              </div>
            </div>
          </div>

          <div className="flex-col-center rightBottomContainer">
            {/* for phone pe window button */}
            {/* {selectedMethod === "credit" && (
              )} */}
            <button className="confirm-btn" onClick={handleConfirmAndPay}>
              Confirm and pay
            </button>

            {/* for paypal payment button */}
            {/* {selectedMethod == "paypal" && <PaypalButton />} */}

            <p className="confirm-pay-section">
              By clicking &quot;Confirm and pay&quot; you agree to our &nbsp;
              <Link
                target="_blank"
                href="https://snapshawt.com/terms-conditions"
                className="terms-of-use"
              >
                Terms and Conditions
              </Link>
            </p>
            <ul className="flex-col-center features">
              <li>100% secure payment encryption</li>
              <li>Instant activation</li>
              <li>24/7 technical service</li>
            </ul>

            {/* left-icons-container */}
            <div className="flex-row-center left-icons-container">
              {paymentImages.map((image, index) => (
                <div key={index} className="payment-icon">
                  <Image
                    src={image}
                    width={150}
                    height={150}
                    alt={`Payment method ${index + 1}`}
                    className={index === 4 ? "paypal-icon" : "payment-icon"}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
